'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input, Icon } from 'dumb';
import { ModalRow } from 'dumb/modal';

import { TableList, TableListCell, TableListRow } from 'dumb/tables/table-list';

// phrases/ constants
import phrases from './../../../shiftplanSeniority.phrases';

class ShiftplanSeniorityBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		// get value from event
		const value = e.target ? e.target.value : e;

		// edits the row in the store
		this.props.editBatchListItem({
			...row,
			...{ [type]: value },
		});
	}

	render() {
		const { batchList, addBatchListItemRow } = this.props;

		return (
			<>
				<TableList>
					<thead>
						<tr>
							<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
							<th>{phrases.MODAL_BATCH_STEP_NAME}</th>
							<th>{phrases.MODAL_BATCH_STEP_DESCRIPTION}</th>
							<th>{phrases.MODAL_BATCH_STEP_BADGE}</th>
							<th>{phrases.MODAL_BATCH_STEP_MINIMUM_HOURS}</th>
							<th>{phrases.MODAL_BATCH_STEP_MAXIMUM_HOURS}</th>

							<th />
						</tr>
					</thead>
					<tbody>
						{batchList.map((entry, i) => {
							const deleteButtonDisabled = batchList.length === 1;

							return (
								<TableListRow key={entry.identifier}>
									<TableListCell>{i + 1}</TableListCell>

									<TableListCell>
										<Input
											id="name"
											placeholder={phrases.MODAL_BATCH_STEP_NAME_PLACEHOLDER}
											value={entry.name || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'name')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="description"
											placeholder={
												phrases.MODAL_BATCH_STEP_DESCRIPTION_PLACEHOLDER
											}
											value={entry.description || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'description')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="badge"
											placeholder={phrases.MODAL_BATCH_STEP_BADGE_PLACEHOLDER}
											value={entry.badge || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'badge')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="minimumHours"
											type="number"
											placeholder={
												phrases.MODAL_BATCH_STEP_MINIMUM_HOURS_PLACEHOLDER
											}
											value={entry.minimumHours || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'minimumHours')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="maximumHours"
											type="number"
											placeholder={
												phrases.MODAL_BATCH_STEP_MAXIMUM_HOURS_PLACEHOLDER
											}
											value={entry.maximumHours || ''}
											onChange={(event) =>
												this._editListEntry(event, entry, 'maximumHours')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Button
											type="negative"
											size="tiny"
											disabled={deleteButtonDisabled}
											onClick={() => this._onRemoveEntry(entry.identifier)}>
											<Icon name="delete" />
										</Button>
									</TableListCell>
								</TableListRow>
							);
						})}
					</tbody>
				</TableList>
				<ModalRow
					typeAddNewRow
					tooltipText={phrases.MODAL_BATCH_STEP_LIST_TOOLTIP}
					tooltipZIndex={600}
					onClick={addBatchListItemRow}
				/>
			</>
		);
	}
}

ShiftplanSeniorityBatchStepList.propTypes = {
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
};

export default ShiftplanSeniorityBatchStepList;
